// document.addEventListener('DOMContentLoaded', function () {

//   const dataElement = document.getElementById('variant-returnable-data');
//   if (!dataElement) return;

//   const variantReturnableMap = JSON.parse(dataElement.textContent);

//   function updateReturnable() {

//     const selectedRadio = document.querySelector('input[name="Size"]:checked');
//     if (!selectedRadio) return;

//     const variantId = selectedRadio.getAttribute('varid');
//     if (!variantId) return;

//     const isReturnable = variantReturnableMap[variantId] ?? false;

//     document.querySelectorAll('[data-returnable="true"]').forEach(el => {
//       el.style.display = isReturnable ? 'block' : 'none';
//     });

//     document.querySelectorAll('[data-returnable="false"]').forEach(el => {
//       el.style.display = isReturnable ? 'none' : 'block';
//     });

//     console.log("Variant:", variantId, "Returnable:", isReturnable);
//   }

//   document.addEventListener('change', function (e) {
//     if (e.target.matches('input[name="Size"]')) {
//       updateReturnable();
//     }
//   });

//   updateReturnable();
// });



document.addEventListener('DOMContentLoaded', function () {

  const dataElement = document.getElementById('variant-returnable-data');
  if (!dataElement) return;

  const variantReturnableMap = JSON.parse(dataElement.textContent);

  function updateReturnable() {

    const selectedRadio = document.querySelector('input[name="Size"]:checked');
    if (!selectedRadio) return;

    const variantId = selectedRadio.getAttribute('varid');
    if (!variantId) return;

    const isReturnable = variantReturnableMap[variantId] ?? false;

    document.querySelectorAll('[data-returnable="true"]').forEach(el => {
      el.style.display = isReturnable ? 'block' : 'none';
    });

    document.querySelectorAll('[data-returnable="false"]').forEach(el => {
      el.style.display = isReturnable ? 'none' : 'block';
    });

    console.log("Variant:", variantId, "Returnable:", isReturnable);
  }

  /* -------------------------
     NORMAL SIZE CHANGE (XS,S,XL...)
  -------------------------- */
  document.addEventListener('change', function (e) {
    if (e.target.matches('input[name="Size"]')) {
      updateReturnable();
    }
  });

  /* -------------------------
     FIX FOR MADE TO ORDER
  -------------------------- */

  // 1️⃣ Page load check (if Made to Order is default selected)
  setTimeout(function() {
    updateReturnable();
  }, 300);

  // 2️⃣ Click on label (important because some themes don't trigger change immediately)
  document.querySelectorAll('label').forEach(label => {
    if (label.textContent.trim().includes('Made to Order')) {
      label.addEventListener('click', function () {
        setTimeout(updateReturnable, 100);
      });
    }
  });

});